// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { floppyDiskPen16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-floppy-disk-pen': IconFloppyDiskPen;
    }
}

/**
 * The icon component for the 'floppyDiskPen' icon
 */
export class IconFloppyDiskPen extends Icon {
    public constructor() {
        super(floppyDiskPen16X16);
    }
}

registerIcon('icon-floppy-disk-pen', IconFloppyDiskPen);
export const iconFloppyDiskPenTag = 'nimble-icon-floppy-disk-pen';
